import { render, staticRenderFns } from "./mine.vue?vue&type=template&id=1240f457&scoped=true"
import script from "./mine.vue?vue&type=script&lang=js"
export * from "./mine.vue?vue&type=script&lang=js"
import style0 from "./mine.vue?vue&type=style&index=0&id=1240f457&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1240f457",
  null
  
)

export default component.exports